import { render, staticRenderFns } from "./_Specifications.vue?vue&type=template&id=0cabbdb0&"
import script from "./_Specifications.vue?vue&type=script&lang=js&"
export * from "./_Specifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports